import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-incidents-add-document-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class IncidentsAddDocumentManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel> {
            name: "Add Document to Incident",
            description: "This endpoint can be used to add a document to an existing incident.",
            httpMethod: "POST",
            path: "/api/incidents/{guid}/add/document",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the incident to add the document to",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "document",
                    description: "single file that should be added to the incident",
                    in: "file",
                    paramType: "formData",
                    required: true,
                    example: "binary",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                }
            ]
        }
    }
}